export function convertBinaryStringToUint8Array (bStr: string): Uint8Array {
  const u8_array = new Uint8Array(bStr.length)
  for (let i = 0; i < bStr.length; i++) {
    u8_array[i] = bStr.charCodeAt(i)
  }
  return u8_array
}